import { FC, useEffect, useState } from 'react';
import { BrandButtonProps } from './types';

const BrandButton: FC<BrandButtonProps> = (props) => {
	const [isSelected, setIsSelected] = useState<boolean>(false);

	useEffect(() => {
		if (props.isSelected) {
			setIsSelected(true);
		} else {
			setIsSelected(false);
		}
	}, [props.isSelected]);

	return (
		<button
			className={`pop-brand-button pop-w-16 pop-h-16 pop-sm:pop-w-16 pop-sm:pop-h-16 ${isSelected ? 'selected' : ''} ${props.className ?? ''}`}
			onClick={props.onClick}
		>
			{props.children}
		</button>
	);
};

export default BrandButton;
